/* =============================================================================
   hub-event-signup.js — ATHLO+ EVENT REGISTRATION (ADDON)
   =============================================================================
   The front door for an ATHLO-LED event: pick a date, leave a name and an email,
   get a door code. Driven by sections/hub-event-signup.liquid.

   WHY THIS IS NOT hub-booking.js WITH A FLAG
   That file exists to sell a PARTNER APPOINTMENT, and almost everything in it is
   about money: it ranks up to three candidate times because a human has to accept
   one, it collects a waiver, and it finishes by POSTing /cart/add.js with line
   item properties and sending the visitor to /checkout. An ATHLO event has no
   partner to accept it, no waiver, no variant and no price - so a "free mode"
   inside that file would be a second flow threaded through a first, and every
   future change to either would have to be checked against both. This is ~340
   lines that share nothing with it but a house style.

   IT DOES NOT TOUCH THE CART, AND THAT IS THE POINT
   assets/hub-exhibition.js refuses /cart/add and /checkout at the network
   boundary while exhibition mode is on. This flow calls the bookings function
   directly and never goes near either path, so a FREE event can be registered for
   while the shop is deliberately unable to take money. That is correct rather
   than a loophole: exhibition mode exists to stop us charging for something we
   cannot yet deliver, and this charges nothing. A PAID event is not registerable
   here at all - the backend refuses any service that is not explicitly
   free_registration with price_cents = 0.

   Note the submit button deliberately avoids name="add" and name="checkout":
   those are two of hub-exhibition.js's SELL_SEL selectors, and a button matching
   one would be relabelled "Preview only" by a script that was right to do it.

   GRACEFUL FAILURE IS PART OF THE SPEC, same doctrine as hub-booking.js: if the
   function is unreachable we render an email fallback, never an empty date list,
   because an empty calendar and a broken one look identical to a customer.

   Backend: supabase-community/supabase/functions/bookings
     GET  ?action=availability&service=<uuid>&from=<iso>&to=<iso>
     POST ?action=bookings-register  { service_id, starts_at, email, name }
     POST ?action=waitlist-join      { service_id, email, customer_name, window_from, window_to }

   Removable: delete this file, assets/hub-event-signup.css and
   sections/hub-event-signup.liquid. Nothing else refers to them.
   ========================================================================== */
(function () {
  'use strict';

  var ROOTS = document.querySelectorAll('[data-event-signup]');
  if (!ROOTS.length) return;

  /* --- tiny helpers, local on purpose (this file ships alone) -------------- */
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text !== null && text !== undefined) n.textContent = String(text);
    return n;
  }
  function add(parent) {
    for (var i = 1; i < arguments.length; i++) if (arguments[i]) parent.appendChild(arguments[i]);
    return parent;
  }
  function clear(n) { while (n.firstChild) n.removeChild(n.firstChild); }
  var EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

  /* Dates are rendered in the EVENT's zone, never the visitor's. Somebody
     travelling must not be told a 7am Singapore run starts at midnight. */
  function fmt(iso, tz, withTime) {
    var d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    var o = { timeZone: tz, weekday: 'short', day: 'numeric', month: 'short' };
    if (withTime) { o.hour = 'numeric'; o.minute = '2-digit'; o.hour12 = true; }
    try { return new Intl.DateTimeFormat('en-SG', o).format(d); } catch (e) { return iso; }
  }
  /* TIME TBA (2026-11-02): when the event's start time is not announced yet the server sends a
     time_note ("Evening, start time to be announced"). The slot's clock time underneath is then a
     placeholder, so it is never printed: the date plus the note instead. */
  function whenText(iso, tz, note) {
    return note ? fmt(iso, tz, false) + ', ' + note : fmt(iso, tz, true);
  }
  // The event's local calendar date as YYYYMMDD (for all-day calendar entries).
  function localDay(ms, tz, addDays) {
    try {
      var p = new Intl.DateTimeFormat('en-CA', { timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date(ms)).split('-');
      var d = new Date(Date.UTC(+p[0], +p[1] - 1, +p[2] + (addDays || 0)));
      return d.toISOString().slice(0, 10).replace(/-/g, '');
    } catch (e) { return ''; }
  }
  function timeOf(iso, tz) {
    var d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    try {
      return new Intl.DateTimeFormat('en-SG',
        { timeZone: tz, hour: 'numeric', minute: '2-digit', hour12: true }).format(d);
    } catch (e) { return ''; }
  }

  function boot(root) {
    var cfgNode = root.querySelector('[data-event-signup-config]');
    var CFG = {};
    try { CFG = JSON.parse(cfgNode.textContent); } catch (e) { CFG = {}; }

    var BASE = (CFG.proxy || '').trim() || (CFG.endpoint || '').trim();
    var TZ = (CFG.tz || 'Asia/Singapore').trim();
    var S = { root: root, slots: [], pick: null, busy: false };

    var host = root.querySelector('[data-event-signup-mount]');
    if (!host) return;

    var PAGE_URL = CFG.pageUrl || window.location.href.split('#')[0].split('?')[0];
    var sheet = null, bar = null;
    S.barReady = false;
    S.going = null;

    function track(action, placement) {
      try {
        if (typeof window.gtag === 'function') {
          window.gtag('event', 'event_signup_' + action, { event_id: CFG.serviceId || '', placement: placement || '' });
        }
      } catch (e) {}
    }

    /* --- "remember me" (setting remember_me, off by default) ---------------
       After registering, this browser keeps the door code so a return visit
       shows "you're going" and the code, instead of an empty form that makes
       people wonder whether it worked. Kept: code, times, title. Never the name
       or email. Verified against the server on every visit, so a place
       cancelled from the email link stops showing here too. */
    var KEY = 'athlo_es_' + (CFG.serviceId || '');
    function readSaved() {
      if (!CFG.remember || !CFG.serviceId) return null;
      try {
        var v = JSON.parse(window.localStorage.getItem(KEY) || 'null');
        if (!v || !v.code) return null;
        var end = Date.parse(v.endsAt || v.startsAt || '');
        if (!isNaN(end) && end < Date.now()) { window.localStorage.removeItem(KEY); return null; }
        return v;
      } catch (e) { return null; }
    }
    function writeSaved(d) {
      if (!CFG.remember || !d || !d.code) return;
      try {
        window.localStorage.setItem(KEY, JSON.stringify({
          code: d.code, startsAt: d.startsAt || '', endsAt: d.endsAt || '', title: d.title || '',
          timeNote: d.timeNote || S.timeNote || '',
        }));
      } catch (e) {}
    }
    function dropSaved() { try { window.localStorage.removeItem(KEY); } catch (e) {} }

    // Other sections (the event page's own Reserve buttons) listen for this so
    // they can say "You're going" too. The class covers a listener that boots late.
    function signalGoing(on) {
      var R = document.documentElement;
      var label = CFG.goingLabel || "You're going · show my code";
      S.going = !!on;
      if (on) { R.classList.add('es-going'); R.setAttribute('data-es-going-label', label); }
      else { R.classList.remove('es-going'); R.removeAttribute('data-es-going-label'); }
      try {
        document.dispatchEvent(new CustomEvent('athlo:event-going',
          { detail: { serviceId: CFG.serviceId, going: !!on, label: label } }));
      } catch (e) {}
      updateBar();
    }

    /* --- transport -------------------------------------------------------- */
    function api(action, opts) {
      opts = opts || {};
      if (!BASE) return Promise.reject(new Error('no endpoint configured'));
      var sep = BASE.indexOf('?') > -1 ? '&' : '?';
      var url = BASE + sep + 'action=' + encodeURIComponent(action) + (opts.query || '');
      var init = { headers: { Accept: 'application/json' } };
      if (opts.body) {
        init.method = 'POST';
        init.headers['Content-Type'] = 'application/json';
        init.body = JSON.stringify(opts.body);
      }
      return fetch(url, init).then(function (r) {
        return r.json().catch(function () { return null; }).then(function (j) {
          if (!j) throw new Error('bad response');
          // The function answers { ok:false, error } with a 4xx, so the error CODE is
          // what the copy below switches on - never the HTTP status, which is the
          // same 400 for "slot taken" and "you typed a bad email".
          if (j.ok === false) { var e = new Error(j.message || j.error || 'failed'); e.code = j.error; throw e; }
          return j.data !== undefined ? j.data : j;
        });
      });
    }

    /* --- the states ------------------------------------------------------- */

    function renderFallback(why) {
      clear(host);
      add(host, el('p', 'es__h', CFG.fbHeading || 'Registration is not loading'));
      add(host, el('p', 'es__sub',
        CFG.fbText || 'We cannot reach the sign-up system right now. Email us and we will put you on the list by hand.'));
      if (CFG.email) {
        var a = el('a', 'es__link', 'Email to register');
        a.href = 'mailto:' + CFG.email + '?subject=' +
          encodeURIComponent('Register: ' + (CFG.title || 'ATHLO+ event'));
        add(host, a);
      }
      if (why && window.console && console.warn) console.warn('hub-event-signup:', why);
    }

    function renderDates() {
      clear(host);
      if (CFG.intro) add(host, el('p', 'es__sub', CFG.intro));

      // Every slot the service generated in the window. A one-off event yields
      // exactly one, which is the common case and gets no picker at all - a list
      // of one is a decision the visitor does not have to be asked to make.
      var open = S.slots.filter(function (s) {
        return typeof s.seats_open !== 'number' || s.seats_open > 0;
      });

      // The two empties are DIFFERENT and must not share copy. No dates at all means nothing is
      // scheduled; dates that are all full means somebody wants in and cannot get in, which is the
      // only one of the two where a waiting list is the right answer.
      if (!S.slots.length) {
        add(host, el('p', 'es__empty',
          CFG.emptyText || 'Nothing on the calendar right now - check back soon.'));
        return;
      }

      if (!open.length || S.allFull) {
        renderFull();
        return;
      }

      // Only now is there something to reserve, so only now may the sticky bar ask.
      S.barReady = true;
      updateBar();

      if (open.length === 1) {
        S.pick = open[0];
        add(host, dateLine(open[0]));
      } else {
        add(host, el('p', 'es__lbl', CFG.pickLabel || 'Pick a date'));
        var list = el('div', 'es__dates');
        open.forEach(function (slot, i) {
          var b = el('button', 'es__date');
          b.type = 'button';
          b.setAttribute('aria-pressed', i === 0 ? 'true' : 'false');
          add(b, el('span', 'es__date-d', fmt(slot.starts_at, TZ, false)));
          add(b, el('small', null, (S.timeNote || timeOf(slot.starts_at, TZ)) + seatsSuffix(slot)));
          b.addEventListener('click', function () {
            S.pick = slot;
            [].forEach.call(list.querySelectorAll('.es__date'), function (o) {
              o.setAttribute('aria-pressed', o === b ? 'true' : 'false');
            });
          });
          add(list, b);
        });
        S.pick = open[0];
        add(host, list);
      }
      add(host, form());
    }

    function seatsSuffix(slot) {
      if (typeof slot.seats_open !== 'number') return '';
      // Scarcity is only shown when it is REAL. "12 spots left" on a 20-place run
      // that nobody has entered is a nudge; on a run with 12 places it is a lie by
      // omission, and either way a number that never moves stops being read.
      if (slot.seats_open <= 0) return ' - full';
      if (slot.seats_open <= (CFG.lowSeats || 5)) {
        return ' - ' + slot.seats_open + (slot.seats_open === 1 ? ' spot left' : ' spots left');
      }
      return '';
    }

    function dateLine(slot) {
      var wrap = el('div', 'es__when');
      add(wrap, el('p', 'es__when-d', whenText(slot.starts_at, TZ, S.timeNote)));
      var extra = [];
      if (CFG.venue) extra.push(CFG.venue);
      var suffix = seatsSuffix(slot).replace(/^ - /, '');
      if (suffix) extra.push(suffix);
      if (extra.length) add(wrap, el('p', 'es__when-m', extra.join(' · ')));
      return wrap;
    }

    function form() {
      var f = el('form', 'es__form');
      f.noValidate = true;

      var name = el('input');
      name.type = 'text'; name.name = 'athlo_name'; name.autocomplete = 'name';
      name.placeholder = CFG.namePlaceholder || 'Your name';
      name.id = 'es-name-' + CFG.sid;

      var email = el('input');
      email.type = 'email'; email.name = 'athlo_email'; email.autocomplete = 'email';
      email.placeholder = CFG.emailPlaceholder || 'you@example.com';
      email.id = 'es-email-' + CFG.sid;
      email.required = true;

      add(f, labelled(CFG.nameLabel || 'Name', name));
      add(f, labelled(CFG.emailLabel || 'Email', email));

      // Optional contact number, off unless the section turns it on. A physical
      // event (a dawn run) wants a way to reach someone; a talk does not.
      var phone = null;
      if (CFG.collectPhone) {
        phone = el('input');
        phone.type = 'tel'; phone.name = 'athlo_phone'; phone.autocomplete = 'tel';
        phone.placeholder = CFG.phonePlaceholder || '+65 9123 4567';
        phone.id = 'es-phone-' + CFG.sid;
        if (CFG.phoneRequired) phone.required = true;
        var phoneField = labelled((CFG.phoneLabel || 'Phone') + (CFG.phoneRequired ? '' : ' (optional)'), phone);
        if (CFG.phoneTuck && !CFG.phoneRequired) {
          // Setting phone_tuck: an optional field is one more box to fill on a phone, so it
          // waits behind a link. Still there for anyone who wants to leave a number.
          phoneField.hidden = true;
          var tuck = el('button', 'es__tuck', '+ Add a ' + (CFG.phoneLabel || 'phone').toLowerCase() + ' number (optional)');
          tuck.type = 'button';
          tuck.addEventListener('click', function () {
            phoneField.hidden = false;
            tuck.hidden = true;
            phone.focus();
          });
          add(f, tuck);
        }
        add(f, phoneField);
      }

      // Yes/no questions from the section's "question" blocks, e.g. a partner's
      // "are you a member?" and their marketing consent. Neither answer is
      // pre-selected: a consent must be an act, never a default. The label goes
      // to the server with the answer, because the wording IS the consent record.
      var questions = (CFG.questions || []).filter(function (q) { return q && q.key && q.label; });
      var qGroups = questions.map(function (q, qi) {
        if (q.kind === 'agree') {
          // An "agreement" block: ONE tickbox (a waiver), never pre-ticked. Unticked
          // means not registered when it is required. The full text lives on its own
          // page, opened in a new tab so a half-filled form is not lost.
          var wrap = el('div', 'es__agree');
          wrap.setAttribute('data-key', q.key);
          var al = el('label', 'es__agree-l');
          var cb = el('input');
          cb.type = 'checkbox'; cb.id = 'es-a-' + CFG.sid + '-' + qi;
          if (q.required) cb.required = true;
          add(al, cb, el('span', null, q.label + (q.required ? '' : ' (optional)')));
          add(wrap, al);
          if (q.linkUrl) {
            var a = el('a', 'es__agree-link', q.linkText || 'Read the full text');
            a.href = q.linkUrl; a.target = '_blank'; a.rel = 'noopener';
            add(wrap, a);
          }
          add(f, wrap);
          return { q: q, fs: wrap, cb: cb };
        }
        var fs = el('fieldset', 'es__q');
        fs.setAttribute('data-key', q.key);
        var lg = el('legend', null, q.label + (q.required ? '' : ' (optional)'));
        add(fs, lg);
        var row = el('div', 'es__q-opts');
        ['yes', 'no'].forEach(function (v) {
          var l = el('label', 'es__q-opt');
          var r = el('input');
          r.type = 'radio'; r.name = 'es-q-' + CFG.sid + '-' + qi; r.value = v;
          if (q.required) r.required = true;
          add(l, r, el('span', null, v === 'yes' ? (q.yes || 'Yes') : (q.no || 'No')));
          add(row, l);
        });
        add(fs, row);
        add(f, fs);
        return { q: q, fs: fs };
      });

      // NOT name="add" and NOT name="checkout" - see the header. Those match
      // hub-exhibition.js's sell selectors and would be relabelled.
      var go = el('button', 'es__go', CFG.cta || 'Register');
      go.type = 'submit';
      add(f, go);

      var err = el('p', 'es__err');
      err.setAttribute('role', 'alert');
      err.hidden = true;
      add(f, err);

      if (CFG.fine) add(f, el('p', 'es__fine', CFG.fine));

      f.addEventListener('submit', function (ev) {
        ev.preventDefault();
        if (S.busy) return;
        err.hidden = true;

        var e = String(email.value || '').trim().toLowerCase();
        if (!EMAIL_RE.test(e)) {
          err.textContent = 'That email does not look right. We need it to send your code.';
          err.hidden = false;
          email.focus();
          return;
        }
        if (!S.pick) {
          err.textContent = 'Pick a date first.';
          err.hidden = false;
          return;
        }
        var ph = phone ? String(phone.value || '').trim() : '';
        if (CFG.phoneRequired && phone && !ph) {
          err.textContent = 'We need a contact number for this event.';
          err.hidden = false;
          phone.focus();
          return;
        }

        var answers = [];
        for (var gi = 0; gi < qGroups.length; gi++) {
          var g = qGroups[gi];
          if (g.cb) {
            if (!g.cb.checked) {
              if (g.q.required) {
                err.textContent = 'Please tick the box to agree to the waiver before you register.';
                err.hidden = false;
                g.cb.focus();
                return;
              }
              continue;
            }
            // The record keeps the page the visitor agreed to beside the sentence they
            // ticked, so "which waiver?" is answerable from the roster alone.
            answers.push({ key: g.q.key, label: ((g.q.record || g.q.label) + (g.q.linkUrl ? ' [' + g.q.linkUrl + ']' : '')).slice(0, 300), answer: 'yes' });
            continue;
          }
          var picked = g.fs.querySelector('input:checked');
          if (!picked) {
            if (g.q.required) {
              err.textContent = 'Please answer: ' + g.q.label;
              err.hidden = false;
              var first = g.fs.querySelector('input');
              if (first) first.focus();
              return;
            }
            continue;
          }
          answers.push({ key: g.q.key, label: g.q.label, answer: picked.value });
        }

        S.busy = true;
        go.disabled = true;
        go.textContent = CFG.ctaBusy || 'Registering...';

        api('bookings-register', {
          body: {
            service_id: CFG.serviceId,
            starts_at: S.pick.starts_at,
            email: e,
            name: String(name.value || '').trim(),
            customer_phone: ph,
            answers: answers.length ? answers : undefined,
          },
        }).then(function (d) {
          // Keep the FIRST registration on this device. Signing a friend up afterwards
          // must not swap your own code for theirs; they get theirs by email.
          if (!readSaved()) writeSaved(d);
          if (CFG.remember) signalGoing(true);
          track('done', sheet && sheet.dlg.open ? 'sheet' : 'inline');
          renderDone(d, e);
        }).catch(function (er) {
          S.busy = false;
          go.disabled = false;
          go.textContent = CFG.cta || 'Register';
          err.textContent = messageFor(er, e);
          err.hidden = false;
          // A taken slot means the board the visitor is looking at is stale, so
          // refresh it under them rather than leaving them to press a button that
          // cannot now work.
          if (er.code === 'slot_taken') load();
        });
      });
      return f;
    }

    function labelled(text, input) {
      var l = el('label', 'es__f');
      var span = el('span', null, text);
      l.setAttribute('for', input.id);
      add(l, span, input);
      return l;
    }

    /* Error copy is per CODE, because "something went wrong" on a sign-up form is
       the message that makes somebody give up rather than try the obvious fix. */
    function messageFor(er, email) {
      switch (er.code) {
        case 'slot_taken':
          return 'That date just filled up. The list below has been refreshed.';
        case 'outside_window':
          return 'That date is no longer open for registration.';
        case 'not_found':
          return 'This event is not taking registrations right now.';
        case 'cap_reached':
        case 'too_many_open':
          return 'You are already registered for a few upcoming sessions. Come to those first, or email us.';
        case 'blocked':
          return 'We cannot register that address. Email us if you think that is wrong.';
        case 'rate_limited':
          return 'That was a lot of tries at once. Wait a moment and go again.';
        default:
          return 'We could not complete that registration' +
            (email ? '' : '') + '. Try again in a moment, or email us and we will do it by hand.';
      }
    }

    // `returning` = shown from this browser's memory on a later visit (remember_me),
    // not straight after submitting, so there is no "on its way to <email>" line.
    function renderDone(d, email, returning) {
      clear(host);
      var code = (d && d.code) || '';
      add(host, el('p', 'es__h', returning
        ? (CFG.goingHeading || "You're going")
        : (CFG.doneHeading || 'You are in')));
      add(host, el('p', 'es__sub',
        (CFG.doneText || 'Show this code when you arrive. We have emailed it to you as well.')));

      if (code) {
        var box = el('div', 'es__code');
        add(box, el('span', 'es__code-l', 'Your code'));
        add(box, el('strong', 'es__code-v', code));
        add(host, box);
      }

      var when = (d && d.startsAt) ? whenText(d.startsAt, TZ, d.timeNote || S.timeNote) : '';
      if (when) add(host, el('p', 'es__when-m', when + (CFG.venue ? ' · ' + CFG.venue : '')));

      if (CFG.extras && code) add(host, afterActions(d, code));

      if (!returning) {
        // Said explicitly because the mail is the thing that fails silently. A
        // visitor who never gets it should know the code on this screen is enough,
        // rather than assume they are not really registered.
        add(host, el('p', 'es__fine',
          'The confirmation is on its way to ' + email + '. If it does not arrive, this code still works - '
          + 'screenshot it.'));
      } else {
        var other = el('button', 'es__tuck', 'Sign up someone else');
        other.type = 'button';
        other.addEventListener('click', function () { load(); });
        add(host, other);
      }
    }

    /* --- after registering: calendar, share, manage (setting done_extras) ---
       The moment somebody has just said yes is the moment they will put it in
       their calendar and send it to a friend. These used to live only above the
       form, where nobody looks again once they are filling it in. */
    function manageUrl(code) {
      return (CFG.manageUrl || '/pages/event-registration') + '?code=' + encodeURIComponent(code);
    }
    function utc(ms) { return new Date(ms).toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, ''); }
    function icsEsc(s) { return String(s).replace(/\\/g, '\\\\').replace(/([,;])/g, '\\$1').replace(/\n/g, '\\n'); }

    function afterActions(d, code) {
      var wrap = el('div', 'es__after');
      var start = Date.parse(d.startsAt || d.starts_at || '');
      var end = Date.parse(d.endsAt || d.ends_at || '');
      if (isNaN(end)) end = start + 2 * 3600000;
      var title = CFG.eventName || d.title || 'ATHLO+ event';
      var note = d.timeNote || d.time_note || S.timeNote || '';
      // Time TBA: all-day entries on the event's local date, never the placeholder slot time.
      var gDates = note ? localDay(start, TZ) + '/' + localDay(start, TZ, 1) : utc(start) + '/' + utc(end);
      var icsWhen = note ? ['DTSTART;VALUE=DATE:' + localDay(start, TZ), 'DTEND;VALUE=DATE:' + localDay(start, TZ, 1)]
                         : ['DTSTART:' + utc(start), 'DTEND:' + utc(end)];
      var manage = manageUrl(code);
      if (manage.charAt(0) === '/') manage = window.location.origin + manage;
      var details = 'Your check-in code: ' + code + '\nManage or cancel: ' + manage + '\nDetails: ' + PAGE_URL;

      var row = el('div', 'es__after-row');
      if (!isNaN(start)) {
        var g = el('a', 'es__btn', 'Google Calendar');
        g.href = 'https://calendar.google.com/calendar/render?action=TEMPLATE'
          + '&text=' + encodeURIComponent(title) + '&dates=' + gDates
          + '&details=' + encodeURIComponent(details) + '&location=' + encodeURIComponent(CFG.venue || '');
        g.target = '_blank';
        g.rel = 'noopener';
        g.addEventListener('click', function () { track('calendar', 'google'); });

        var ics = el('button', 'es__btn', 'Apple / Outlook');
        ics.type = 'button';
        ics.addEventListener('click', function () {
          var body = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//ATHLO+//Event//EN', 'CALSCALE:GREGORIAN', 'METHOD:PUBLISH',
            'BEGIN:VEVENT', 'UID:' + code + '@athlo.sg', 'DTSTAMP:' + utc(Date.now()),
            icsWhen[0], icsWhen[1], 'SUMMARY:' + icsEsc(title),
            'LOCATION:' + icsEsc(CFG.venue || ''), 'DESCRIPTION:' + icsEsc(details), 'URL:' + PAGE_URL,
            'END:VEVENT', 'END:VCALENDAR'].join('\r\n');
          var a = document.createElement('a');
          a.href = 'data:text/calendar;charset=utf-8,' + encodeURIComponent(body);
          a.download = (title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'event') + '.ics';
          document.body.appendChild(a); a.click(); a.parentNode.removeChild(a);
          track('calendar', 'ics');
        });
        add(row, g, ics);
      }

      var share = el('button', 'es__btn', 'Share with a friend');
      share.type = 'button';
      share.addEventListener('click', function () {
        // The page, never the code: a door code is one person's place.
        var data = { title: title, text: CFG.shareText || title, url: PAGE_URL };
        track('share', navigator.share ? 'native' : 'copy');
        if (navigator.share) { navigator.share(data).catch(function () {}); return; }
        if (navigator.clipboard) {
          navigator.clipboard.writeText(PAGE_URL).then(function () {
            share.textContent = 'Link copied';
            setTimeout(function () { share.textContent = 'Share with a friend'; }, 2200);
          }, function () {});
        }
      });
      add(row, share);

      // WhatsApp (setting whatsapp_share). Runners organise in WhatsApp groups, so this is
      // the share that travels: one tap, message and link already typed. The page, never the code.
      if (CFG.whatsapp) {
        var wa = el('a', 'es__btn es__btn--wa', 'Send on WhatsApp');
        wa.href = 'https://wa.me/?text=' + encodeURIComponent((CFG.waText || CFG.shareText || title) + ' ' + PAGE_URL);
        wa.target = '_blank';
        wa.rel = 'noopener';
        wa.addEventListener('click', function () { track('share', 'whatsapp'); });
        add(row, wa);
      }
      add(wrap, row);

      var m = el('a', 'es__mlink', "Can't make it? Manage or cancel");
      m.href = manageUrl(code);
      add(wrap, m);
      return wrap;
    }

    /* --- full: offer the waitlist rather than a dead end ------------------- */
    function renderFull() {
      clear(host);
      add(host, el('p', 'es__h', CFG.fullHeading || 'This one is full'));
      add(host, el('p', 'es__sub',
        CFG.fullText || 'Leave your email and we will tell you the moment a place opens up. Places do come back.'));

      var f = el('form', 'es__form');
      f.noValidate = true;
      var email = el('input');
      email.type = 'email'; email.name = 'athlo_wl_email'; email.autocomplete = 'email';
      email.placeholder = CFG.emailPlaceholder || 'you@example.com';
      email.id = 'es-wl-' + CFG.sid;
      add(f, labelled(CFG.emailLabel || 'Email', email));
      var go = el('button', 'es__go', 'Join the waiting list');
      go.type = 'submit';
      add(f, go);
      var err = el('p', 'es__err');
      err.setAttribute('role', 'alert');
      err.hidden = true;
      add(f, err);
      add(host, f);

      f.addEventListener('submit', function (ev) {
        ev.preventDefault();
        var e = String(email.value || '').trim().toLowerCase();
        if (!EMAIL_RE.test(e)) {
          err.textContent = 'That email does not look right.';
          err.hidden = false;
          return;
        }
        go.disabled = true;
        go.textContent = 'Adding you...';
        // The window is the event itself, not an open-ended range: this person
        // wants THIS run, and a waitlist entry that also fires for an unrelated
        // date three weeks later is how a helpful email becomes spam.
        var first = S.slots[0] || {};
        var last = S.slots[S.slots.length - 1] || first;
        api('waitlist-join', {
          body: {
            service_id: CFG.serviceId,
            email: e,
            window_from: first.starts_at,
            window_to: last.ends_at || last.starts_at,
          },
        }).then(function () {
          clear(host);
          add(host, el('p', 'es__h', 'You are on the list'));
          add(host, el('p', 'es__sub',
            'We will email ' + e + ' the moment a place opens up. First come, first served from there.'));
        }).catch(function (er) {
          go.disabled = false;
          go.textContent = 'Join the waiting list';
          err.textContent = messageFor(er, e);
          err.hidden = false;
        });
      });
    }

    /* --- how many are going (setting show_count, off by default) ------------
       Seats taken on the event's upcoming date(s), from the same public event-dates
       read the form already makes, plus any number the organiser typed in for
       sign-ups taken elsewhere. Shown only from count_min up: below that nothing
       renders, so an early quiet week never reads as an empty event. */
    function datesQuery() {
      var from = new Date().toISOString();
      var to = new Date(Date.now() + (CFG.days || 60) * 86400000).toISOString();
      return '&service=' + encodeURIComponent(CFG.serviceId) +
             '&from=' + encodeURIComponent(from) + '&to=' + encodeURIComponent(to);
    }
    function showCount(d) {
      if (!CFG.count || !d || !d.dates || !d.dates.length) return;
      var n = 0;
      d.dates.forEach(function (x) {
        var cap = Number(x.capacity || d.capacity) || 0;
        if (typeof x.seats_open === 'number' && cap) n += Math.max(0, cap - x.seats_open);
      });
      n += Math.max(0, parseInt(CFG.countExtra, 10) || 0);
      if (n < Math.max(1, Number(CFG.countMin) || 30)) return;
      var txt = (CFG.countLabel || '{n} going').replace('{n}', n);
      // Not in the phone's sticky bar: it sits between two round buttons, and "Free · 40 going"
      // squeezed "Reserve your spot" down to "RESERVE ..." (harness, 2026-11-03).
      var hooks = document.querySelectorAll('[data-es-count]');
      [].forEach.call(hooks, function (h) {
        var only = h.getAttribute('data-es-count');
        if (only && only !== CFG.serviceId) return;
        h.textContent = (h.getAttribute('data-es-count-prefix') || '') + txt;
        h.hidden = false;
      });
      try {
        document.dispatchEvent(new CustomEvent('athlo:event-count',
          { detail: { serviceId: CFG.serviceId, count: n, label: txt } }));
      } catch (e) {}
    }

    /* --- load ------------------------------------------------------------- */
    function load() {
      if (!CFG.serviceId) {
        // In the theme editor this is a setup mistake worth naming; to a customer
        // it is just a section that should not be on the page.
        if (CFG.editor) renderFallback('no serviceId set on the section');
        else root.hidden = true;
        return;
      }
      clear(host);
      add(host, el('p', 'es__sub', 'Loading dates...'));

      // event-dates, NOT availability. The paid widget's availability route drops any slot with no
      // seats left, which is correct there and useless here: a sold-out run and a run that was never
      // scheduled both come back empty, so the page would say "nothing on the calendar" to somebody
      // who would gladly join the waiting list. event-dates returns the full ones too, flagged.
      api('event-dates', { query: datesQuery() }).then(function (d) {
        S.slots = (d && d.dates) || [];
        S.allFull = !!(d && d.all_full);
        S.timeNote = (d && d.time_note) || '';
        renderDates();
        showCount(d);
      }).catch(function (er) {
        renderFallback(er.message || er);
      });
    }

    /* --- manage / cancel mode ---------------------------------------------
       Reached from the confirmation email's "Manage my registration" link,
       which carries ?code=E......... The same section serves both jobs: sign
       up when there is an Event ID and no code, manage a place when a code is
       present. The manage page needs no Event ID. */
    function currentCode() {
      try {
        var m = (window.location.search || '').match(/[?&]code=([^&#]+)/i);
        return m ? decodeURIComponent(m[1]).trim().toUpperCase() : '';
      } catch (e) { return ''; }
    }

    function renderManage(d) {
      clear(host);
      var cancelled = d.status === 'cancelled';
      add(host, el('p', 'es__h', cancelled ? 'Registration cancelled' : (CFG.manageHeading || 'Your registration')));
      if (d.title) add(host, el('p', 'es__sub', d.title));
      var when = d.starts_at ? whenText(d.starts_at, TZ, d.time_note) : '';
      if (when) add(host, el('p', 'es__when-m', when + (CFG.venue ? ' · ' + CFG.venue : '')));

      if (d.code && !cancelled) {
        var box = el('div', 'es__code');
        add(box, el('span', 'es__code-l', 'Your code'));
        add(box, el('strong', 'es__code-v', d.code));
        add(host, box);
      }
      if (cancelled) {
        add(host, el('p', 'es__fine', 'Your place has been released for the waiting list. If that was a mistake, sign up again from the event page.'));
        return;
      }
      if (d.checked_in) {
        add(host, el('p', 'es__fine', 'You have already been checked in at this event.'));
        return;
      }
      if (!d.cancellable) return;

      var go = el('button', 'es__go es__go--ghost', CFG.cancelCta || "Can't make it? Cancel my spot");
      go.type = 'button';
      var err = el('p', 'es__err'); err.setAttribute('role', 'alert'); err.hidden = true;
      var busy = false;
      go.addEventListener('click', function () {
        if (busy) return;
        // The code is the credential, so the click must be deliberate: a confirm
        // step is the whole safety model for a code-authorised cancel.
        if (!window.confirm('Release your place for ' + (d.title || 'this event') + '? This cannot be undone.')) return;
        busy = true; go.disabled = true; go.textContent = 'Cancelling...';
        api('event-cancel', { body: { code: d.code } }).then(function () {
          renderManage({ code: d.code, title: d.title, starts_at: d.starts_at, time_note: d.time_note, status: 'cancelled' });
        }).catch(function (er) {
          busy = false; go.disabled = false; go.textContent = CFG.cancelCta || "Can't make it? Cancel my spot";
          err.textContent = messageFor(er, '');
          err.hidden = false;
        });
      });
      add(host, go, err);
    }

    function loadManage(code) {
      clear(host);
      add(host, el('p', 'es__sub', 'Loading your registration...'));
      api('event-status', { query: '&code=' + encodeURIComponent(code) })
        .then(function (d) { d.code = d.code || code; renderManage(d); })
        .catch(function () {
          clear(host);
          add(host, el('p', 'es__h', 'Registration not found'));
          add(host, el('p', 'es__sub',
            'We could not find a registration for that link. It may already have been cancelled. Email us if you think that is wrong.'));
        });
    }

    /* --- quick reserve: the form as a sheet (setting quick_sheet) ----------
       Every link to this section's anchor (#register) opens the SAME card in a
       sheet over the page instead of scrolling the visitor 7 screens down to it.
       The card is MOVED, not copied, so there is one form and one state; it goes
       back into the page when the sheet closes. On a phone a slim sticky bar
       keeps "Reserve" one tap away while the programme is being read.
       No <dialog> support (very old browsers) = no sheet: the links scroll to
       the form exactly as they did before this existed. */
    function setupSheet() {
      var anchor = root.id;
      var card = root.querySelector('.es__card');
      if (!anchor || !card) return;
      var dlg = document.createElement('dialog');
      if (typeof dlg.showModal !== 'function') return;
      dlg.className = 'es es-sheet';
      dlg.setAttribute('data-lenis-prevent', '');
      dlg.setAttribute('aria-label', CFG.title || 'Register');
      var x = el('button', 'es-sheet__x', '×');
      x.type = 'button';
      x.setAttribute('aria-label', 'Close');
      var inner = el('div', 'es-sheet__in');
      add(dlg, x, inner);
      document.body.appendChild(dlg);

      // Holds the card's place (and height) in the page while it is in the sheet,
      // so nothing behind the sheet jumps.
      var ph = el('div', 'es__ph');
      var opener = null;
      var R = document.documentElement;

      function open(from, placement) {
        if (dlg.open) return;
        opener = from || null;
        ph.style.height = card.offsetHeight + 'px';
        card.parentNode.insertBefore(ph, card);
        inner.appendChild(card);
        dlg.showModal();
        R.classList.add('es-sheet-open');
        if (window.__lenis && window.__lenis.stop) window.__lenis.stop();
        var t = card.querySelector('.es__title');
        if (t) {
          t.setAttribute('tabindex', '-1');
          try { t.focus({ preventScroll: true }); } catch (e) { t.focus(); }
        }
        inner.scrollTop = 0;
        track('sheet_open', placement);
        updateBar();
      }

      dlg.addEventListener('close', function () {
        if (ph.parentNode) {
          ph.parentNode.insertBefore(card, ph);
          ph.parentNode.removeChild(ph);
        }
        R.classList.remove('es-sheet-open');
        if (window.__lenis && window.__lenis.start) window.__lenis.start();
        if (opener && opener.focus) { try { opener.focus({ preventScroll: true }); } catch (e) {} }
        updateBar();
      });
      // A tap on the dimmed page (the dialog's own box, outside the inner panel) closes it.
      dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
      x.addEventListener('click', function () { dlg.close(); });

      // Listen on each link, not on document: assets/hub-app.js smooth-scrolls every
      // in-page anchor from a document listener, and stopping the click here keeps
      // the page from scrolling away under the sheet. The link's own listeners
      // (the event page's analytics) still run.
      var links = document.querySelectorAll('a[href="#' + anchor + '"]');
      [].forEach.call(links, function (a) {
        a.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          open(a, a.closest && a.closest('.ss-end') ? 'closing' : (a.closest && a.closest('.ss-hero') ? 'hero' : 'link'));
        });
      });

      sheet = { open: open, dlg: dlg };

      // Arriving on page#register (the Instagram bio link) opens the sheet over the
      // TOP of the page, so closing it shows the event, not the bottom of it.
      if ((window.location.hash || '') === '#' + anchor) {
        // The browser's own jump to the anchor can land AFTER this runs, so drop the
        // hash and go to the top again once the page has loaded.
        var toTop = function () {
          if (window.__lenis && window.__lenis.scrollTo) window.__lenis.scrollTo(0, { immediate: true });
          window.scrollTo(0, 0);
        };
        try { history.replaceState(history.state, '', window.location.pathname + window.location.search); } catch (e) {}
        toTop();
        open(null, 'deeplink');
        if (document.readyState !== 'complete') window.addEventListener('load', function () { setTimeout(toTop, 0); });
        else setTimeout(toTop, 0);
      }
    }

    function setupBar() {
      if (!sheet) return;
      bar = el('button', 'es-bar');
      bar.type = 'button';
      bar.setAttribute('aria-hidden', 'true');
      bar.tabIndex = -1;
      S.barLabel = el('span', 'es-bar__l', CFG.barLabel || 'Reserve your spot');
      S.barNote = el('span', 'es-bar__n', CFG.barNote || '');
      add(bar, S.barLabel, CFG.barNote ? S.barNote : null);
      document.body.appendChild(bar);
      bar.addEventListener('click', function () { sheet.open(bar, 'bar'); });

      // Straight off the scroll event, no rAF: updateBar reads two numbers and
      // toggles a class that is usually already set, so there is nothing to batch.
      window.addEventListener('scroll', updateBar, { passive: true });
      updateBar();
    }

    // Up only when there is something to reserve (or a code to show), the visitor is
    // past the hero (which has its own button), the form itself is not on screen,
    // and the sheet is shut. Phones only - the CSS hides it on wider screens.
    function updateBar() {
      if (!bar) return;
      if (S.barLabel) {
        S.barLabel.textContent = S.going
          ? (CFG.goingLabel || "You're going · show my code")
          : (CFG.barLabel || 'Reserve your spot');
      }
      if (S.barNote) S.barNote.hidden = !!S.going;
      var r = root.getBoundingClientRect();
      var inView = r.top < window.innerHeight && r.bottom > 0;
      var on = (S.barReady || S.going) && !inView && !(sheet && sheet.dlg.open)
        && (window.pageYOffset || 0) > window.innerHeight * 0.8;
      bar.classList.toggle('is-on', !!on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      bar.tabIndex = on ? 0 : -1;
    }

    // A code in the URL always means "manage this place", whatever else the
    // section is set up for. Otherwise sign up - or, on a bare manage page opened
    // with no code, say so gently rather than showing an empty box.
    var _code = currentCode();
    if (_code) {
      loadManage(_code);
    } else if (CFG.managePage) {
      clear(host);
      add(host, el('p', 'es__sub',
        'Open the "Manage my registration" link from your confirmation email to view or cancel your place.'));
    } else {
      if (CFG.sheet && !CFG.editor && CFG.serviceId) {
        setupSheet();
        setupBar();
      }
      var saved = readSaved();
      if (saved) {
        // Show the place straight away from memory, then check it with the server:
        // a place cancelled from the email link must stop showing here.
        renderDone(saved, '', true);
        signalGoing(true);
        if (CFG.count) api('event-dates', { query: datesQuery() }).then(showCount).catch(function () {});
        api('event-status', { query: '&code=' + encodeURIComponent(saved.code) }).then(function (d) {
          var st = String((d && d.status) || '').toLowerCase();
          if (st === 'cancelled' || st === 'canceled' || st === 'expired') {
            dropSaved(); signalGoing(false); load();
          }
        }).catch(function (er) {
          // Only a definite "no such registration" forgets it. A network blip must
          // not wipe somebody's door code off their phone.
          if (er && (er.code === 'not_found' || er.code === 'bad_input')) {
            dropSaved(); signalGoing(false); load();
          }
        });
      } else {
        load();
      }
    }
  }

  [].forEach.call(ROOTS, boot);
}());
